module.exports = __webpack_public_path__ + "img/FR12240.1738789b.svg";